const THEME_CONFIG = {
  token: {
    colorPrimary: '#c2185b',
    borderRadius: 8,
    fontFamily: "'Poppins', sans-serif",
    colorLink: '#c2185b',
    colorLinkHover: '#a01550',
  },
  components: {
    Button: { primaryShadow: 'none' },
    Card: { borderRadiusLG: 15 },
  },
};

export default THEME_CONFIG;
